__turbopack_context__.v({
  "block": "_rnKea_block",
  "bordered": "_rnKea_bordered",
  "btn": "_rnKea_btn",
  "buttonDiv": "_rnKea_buttonDiv",
  "danger": "_rnKea_danger",
  "default": "_rnKea_default",
  "dense": "_rnKea_dense",
  "disabled": "_rnKea_disabled",
  "fab": "_rnKea_fab",
  "facebook": "_rnKea_facebook",
  "google": "_rnKea_google",
  "grayDark": "_rnKea_grayDark",
  "grayLight": "_rnKea_grayLight",
  "iconed": "_rnKea_iconed",
  "linkBtn": "_rnKea_linkBtn",
  "linkedin": "_rnKea_linkedin",
  "primary": "_rnKea_primary",
  "raised": "_rnKea_raised",
  "rounded": "_rnKea_rounded",
  "secondary": "_rnKea_secondary",
  "success": "_rnKea_success",
  "twitter": "_rnKea_twitter",
  "warning": "_rnKea_warning",
  "xing": "_rnKea_xing",
});
